module.exports = __webpack_public_path__ + "img/Butterfly_00103.11c96030.png";